export default __webpack_public_path__ + "static/media/big_bg.31e6e03e.png";